import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { manageUserService } from "../../../commons";
import { UserStatusEnum } from "../../../commons/enums/user-status-enum";

interface IUserActiveState {
  userUnassignAsAdminStatus: StatusEnum;
}

const initialState: IUserActiveState = {
  userUnassignAsAdminStatus: StatusEnum.Idle,
};

export const userUnassignAsAdmin = createAsyncThunk(
  "userUnassignAsAdmin",
  async (userId: number, thunkAPI) => {
    try {
      const userUnassignAsAdminResponse =
        await manageUserService.removeUserFromAdmin(userId);
      return userUnassignAsAdminResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const userUnassignAsAdminSlice = createSlice({
  name: "userUnassignAsAdmin",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(userUnassignAsAdmin.pending, (state) => {
        state.userUnassignAsAdminStatus = StatusEnum.Loading;
      })
      .addCase(userUnassignAsAdmin.fulfilled, (state, action) => {
        state.userUnassignAsAdminStatus = StatusEnum.Succeeded;
      })
      .addCase(userUnassignAsAdmin.rejected, (state) => {
        state.userUnassignAsAdminStatus = StatusEnum.Failed;
      });
  },
});

export default userUnassignAsAdminSlice.reducer;
